import logger from "@/utils/logger";

/**
 * Track when user opens the reviews modal
 */
export const trackReviewsModalOpen = (companyName, webDomain) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "reviews_modal_open", {
      company_name: companyName,
      web_domain: webDomain,
    });
  } else {
    logger.debug("GTAG not available", { event: "reviews_modal_open", companyName, webDomain });
  }
};

/**
 * Track when user closes the reviews modal
 */
export const trackReviewsModalClose = (companyName, webDomain) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "reviews_modal_close", {
      company_name: companyName,
      web_domain: webDomain,
    });
  } else {
    logger.debug("GTAG not available", { event: "reviews_modal_close", companyName, webDomain });
  }
};

/**
 * Track when user clicks "Read More" to expand a review
 */
export const trackReviewReadMore = (companyName, reviewAuthor) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "review_read_more", {
      company_name: companyName,
      review_author: reviewAuthor,
    });
  } else {
    logger.debug("GTAG not available", { event: "review_read_more", companyName, reviewAuthor });
  }
};

/**
 * Track when user navigates to next review in overlay
 */
export const trackReviewNext = (companyName) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "review_next", {
      company_name: companyName,
    });
  } else {
    logger.debug("GTAG not available", { event: "review_next", companyName });
  }
};

/**
 * Track when user scrolls through reviews table
 */
export const trackReviewsScroll = (companyName) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "reviews_scroll", {
      company_name: companyName,
    });
  } else {
    logger.debug("GTAG not available", { event: "reviews_scroll", companyName });
  }
};

/**
 * Track when user clicks CTA button in reviews modal
 */
export const trackReviewsCTA = (companyName, location) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "reviews_cta_click", {
      company_name: companyName,
      location: location, // 'modal' or 'overlay'
    });
  } else {
    logger.debug("GTAG not available", { event: "reviews_cta_click", companyName, location });
  }
};
